export default __webpack_public_path__ + "static/reading-b3376a2f6d47812677f6dfd1ff05a72f.png";